module.exports = __webpack_public_path__ + "img/hero_prague.8b778dfd.svg";